import { render, staticRenderFns } from "./PersonalInfoSection.vue?vue&type=template&id=27f828ec&"
import script from "./PersonalInfoSection.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports